module.exports = __webpack_public_path__ + "img/stairs.b310e27d.svg";